<template>
    <!-- 背包窗口 -->
    <div class="pocket">
        <el-dialog customClass="wrap" title="我的背包" :visible.sync="dialogTableVisible" :before-close="ai_dialog_close" :modal-append-to-body="false">
            <div class="itembg" v-loading="loading">
            <div id="itemtitle">
                我的物品<label v-show="myPocketItems != null">（{{myPocketItems.length}}/{{POCKET_VOLUME}}）</label>
                <el-button type="primary" plain size="mini" @click="stackItems();">堆叠</el-button>
            </div>
            <div id="itemlist">
                <div v-show="myPocketItems != null" v-for="(item,index) in myPocketItems" v-bind:key="index"
                ref="item" class="itemdiv" :id="item.itemId + '_item'">
                    <!-- D8：大力丸「可激活」红点提示，引导消耗 -->
                    <span v-if="item.itemName === '大力丸' && item.usable == 1" class="activate-dot" title="可激活：点击使用"></span>
                    <FantasyItemCard :item="item">
                      <div class="opts">
                        <a v-if="item.usable == 1 && item.state !== 'spoiled'" @click="useitem(item);">使用</a>
                        <a v-if="item.equip == 1 && item.state !== 'spoiled'" @click="useitem(item);">装备</a>
                        <a v-if="item.stackCount > 1" @click="splitItem(item.itemId);">拆分</a>
                        <!-- 绑定道具（bind_flag=1，如澡票）不显示「扔掉」，防小号丢地面大号捡的多账号转移（后端 dropItem 同步硬拦） -->
                        <a v-if="item.treasure == 0 && item.bindFlag != 1" @click="dropitem(item.itemId, index);">扔掉</a>
                        <a @click="delItem(item.itemId, index);">删除</a>
                      </div>
                    </FantasyItemCard>
                </div>
            </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {postRequest, postJson, onResult} from '../../utils/api'
import Message from 'element-ui/lib/message'
import FantasyItemCard from '../common/FantasyItemCard'
import pocketActions from '../common/pocketActions'
export default {
  name: 'pocket',
  components: { FantasyItemCard },
  mixins: [pocketActions],
  props:{
    dialogTableVisible: {
      type: Boolean,
      default: false
    },
    pocketItems: Array,
    // 2026-10-30：面板 loading 改为由调用方驱动（streetleft / streetQuickBar）。
    // 原来 loading 是本地 data 且从未置 true —— 打开背包时先清空列表再发请求，
    // 玩家看到的是「空白弹窗停一下、图标才一起涌出」，主观就是卡。
    // 数据量大时（背包满 30 格 + 30 张图）这个空窗更明显。
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
        myPocketItems: [],
        items: [],
        cityMap: {},
    };
  },
  watch: {
      pocketItems: {
        handler(newVal, oldVal) {
          if (newVal != null) {
            this.myPocketItems = newVal;
          }
        }
      },
  },
  mounted: function () {
    this.$root.eventHub.$on('cityMap', this.initCityMap);
  },
  methods: {
    ai_dialog_close(){
      this.$emit("ai_dialog_close");
    },
    initCityMap(cityMap) {
        this.cityMap = cityMap;
    },
    //使用道具
    useitem: function(item, index){
        let _this = this;
        let itemId = item.itemId;
        this.$confirm(this.useConfirmMessage(item), '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            // 效果行是多行文本：MessageBox 对字符串 message 纯文本插值，\n 默认塌成空格，
            // 靠这个类开 white-space:pre-line（样式在 App.vue 全局，不碰 HTML 注入面）
            customClass: 'effect-multiline'
        }).then(function () {
            postRequest('/item/item/useItem', {
                mapId: _this.cityMap.id,
                itemId: itemId
            }).then(resp=> {
                onResult(resp, {
                    success: data => {
                        Message.success("道具使用成功");
                        _this.myPocketItems = data.data;
                        _this.$store.dispatch('user/fetchUserDetail');
                        if (data.message) Message.success(data.message);
                        // buff_v1：食物可能授予/顶替限时增益，通知 buff 栏立即刷新
                        _this.$root.eventHub.$emit('buffRefresh');
                    }
                });
            });
        }, function () {
            //取消
        })
    },
    // 堆肥（perish_v1.2）：堆肥固定在果园堆肥点办理，背包不再提供入口
    //丢掉道具
    dropitem: function(itemId, index){
        let _this = this;
        this.$confirm('您确定要丢掉道具吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(function () {
            postJson('/item/item/dropItem', {
                mapId: _this.cityMap.id,
                itemId: itemId
            }).then(resp=> {
                onResult(resp, {
                    success: data => {
                        _this.myPocketItems = data.data.curContainerItems;
                        _this.items = data.data.items;
                        Message.success("道具丢掉成功");
                        _this.$root.eventHub.$emit('items', _this.items);
                    }
                });
            });
        }, function () {
            //取消
        })
    },
    //使用道具
    //删除/堆叠/拆分 逻辑已抽到 pocketActions mixin
  },
  beforeDestroy: function() {
    this.$root.eventHub.$off('cityMap', this.initCityMap);
  }
}
</script>

<style scoped>
a {
    cursor: pointer;
    color: blue;
}
{
    width:100%;
}
.wrap {
    margin:auto;
}
.itembg {
    width:100%;
    height: 400px;
}
#itemtitle {
    padding:3px 5px;
    background-color:#72b653;
    font-size:16px;
    font-weight:bold;
    color:#fff;
    letter-spacing:5px; 
    text-align:center;
}
#itemlist {
    padding:5px;
    text-align:center;
    max-height: 340px;
    overflow-y: auto;
}
#itemcontrol {
    margin:5px;
    line-height: 40px;
    text-align: left;
}
#itemcontrol input,label,select {
    vertical-align:middle;
}
.itemdiv {
    height:120px;
    width:70px;
    float:left;
    position:relative;
    margin:5px;
}
.activate-dot {
    position:absolute;
    top:2px;
    right:8px;
    width:9px;
    height:9px;
    border-radius:50%;
    background:#f56c6c;
    box-shadow:0 0 4px #f56c6c;
    z-index:5;
    cursor:pointer;
}
.itemdiv input {
    position:absolute;
    top:0;
    left:0;
}
.itemdiv img {
    height:40px;
}
.itemName {
  font-size: 11px;
  color: #333;
  line-height: 1.3;
  text-align: center;
  word-break: break-all;
  padding: 2px 0;
  overflow: hidden;
  max-height: 28px;
}
.itemInfo {
  font-size: 10px;
  color: #888;
  line-height: 1.2;
  text-align: center;
}
.itemdiv .stackCount {
  position: absolute;
  bottom: 36px;
  font-size: 0.7em;
  width: 100%;
}
.opts {
    position:absolute;
    display: none;
    background-color: #aaa;
    z-index: 10;
    width: 50px;
    border:1px solid #f00;
}
.opts a {
    display: block;
    padding: 5px;
    margin: auto;
    text-decoration: none;
}
.opts a:hover {
    text-decoration: underline;
    background-color: #666;
    color: #fff;
}
.itemdiv:hover .opts {
    display:block;
    position:absolute;
    top:30px;
    left:50px;
}

/* ========== 移动端适配 ========== */
@media (max-width: 768px) {
  .itembg {
    height: auto;
    max-height: 60vh;
  }
  #itemlist {
    max-height: calc(60vh - 50px);
  }
  .itemdiv {
    width: 60px;
    height: 110px;
    margin: 3px;
  }
  .itemdiv img {
    height: 32px;
  }
}
</style>